import { BLOCK_TITLES, BLOCKS } from '@constants';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import { StyledBlockButtonsBox } from '@styles/app.styles';
import BlockButton from './block-button';

const MainList = () => {
	const { sortedViolations } = useScannerWizardContext();

	return (
		<StyledBlockButtonsBox>
			{Object.keys(sortedViolations).flatMap((key) => {
				if (sortedViolations[key].length < 1) {
					return [];
				}

				const count = sortedViolations[key].length;

				return (
					<BlockButton
						key={key}
						title={BLOCK_TITLES[key]}
						count={count}
						block={BLOCKS[key]}
					/>
				);
			})}
		</StyledBlockButtonsBox>
	);
};

export default MainList;
